class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));

    if (this.matches('.pfk-header-nav__learn')) {
      this.desktopHoverQuery = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)');
      this.addEventListener('pointerenter', this.onPointerEnter.bind(this));
      this.addEventListener('pointerleave', this.onPointerLeave.bind(this));
    }
  }

  onPointerEnter(event) {
    if (!this.desktopHoverQuery?.matches || event.pointerType !== 'mouse') return;

    clearTimeout(this.hoverCloseTimer);
    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
  }

  onPointerLeave(event) {
    if (!this.desktopHoverQuery?.matches || event.pointerType !== 'mouse') return;

    clearTimeout(this.hoverCloseTimer);
    this.hoverCloseTimer = setTimeout(() => {
      if (!this.matches(':hover') && !this.contains(document.activeElement)) this.close();
    }, 150);
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
